<template>
    <div>
        <kgr-dropdown
            :inline="inline"
            display="name"
            :label="label"
            :options="filteredSections"
            :value="value"
            :loading="loading"
            :default-text="defaultText"
            @post-input="onInput"
        />
    </div>
</template>

<script>
import Dropdown from './Dropdown.vue';
import EventBus from '../../../../js/service/EventBus';
import Section from '../../../../js/dto/Section';
import SectionRepository from '../../../../js/repository/SectionRepository';

export default {
    components: {
        'kgr-dropdown': Dropdown,
    },
    props: {
        federationId: {
            type: Number,
            required: true,
        },
        value: {
            type: Section,
            required: false,
            default: null,
        },
        excludedIds: {
            type: Array,
            required: false,
            default: () => {
                return []
            },
        },
        hideLabel: {
            type: Boolean,
            required: false,
            default: false,
        },
        inline: {
            type: Boolean,
            required: false,
            default: false,
        },
        defaultText: {
            type: String,
            required: false,
        },
    },
    data() {
        return {
            loading: true,
            sections: [],
            unsubscribeSection: null,
        }
    },
    computed: {
        label() {
            return this.hideLabel ? null : this.$t('section');
        },
        filteredSections() {
            return this.sections.filter(section => this.excludedIds.indexOf(section.id) === -1);
        }
    },
    created() {
        this.loadSections();
        this.unsubscribeSection = EventBus.$on('section:changed', (federationId) => {
            if (federationId === this.federationId) {
                this.loadSections();
            }
        });
    },
    beforeUnmount() {
        this.unsubscribeSection?.();
    },
    methods: {
        loadSections() {
            this.loading = true;
            SectionRepository
                .findAll(this.federationId)
                .then(data => {
                    this.sections = data;
                })
                .catch(() => this.$notify.error('error.loadingData'))
                .finally(() => { this.loading = false; });
        },
        onInput(value) {
            this.$emit('input', value);
            this.$nextTick(() => {
                this.$emit('post-input', value);
            });
        },
    }
}
</script>
